<template>
  <div align-h="end">
    <b-col lg="12" md="12" class="pr-lg-2">
      <base-input :label="$t('report.reason')" v-model="report.reason"></base-input>
    </b-col>

    <b-col lg="12" md="12" class="pr-lg-2">
      <base-textarea :label="$t('report.history')" v-model="report.history" :rows=5 :maxRows=12 ></base-textarea>
    </b-col>

    <b-col lg="12" md="12" class="pr-lg-2">
      <base-textarea :label="$t('report.diagnosis')" v-model="report.diagnosis" :rows=5 :maxRows=12 ></base-textarea>
    </b-col>

    <b-col lg="12" md="12" class="pr-lg-2">
      <base-textarea :label="$t('report.treatment')" v-model="report.treatment" :rows=5 :maxRows=12 ></base-textarea>
    </b-col>
  </div>
</template>


<script>
import { BIcon, BIconStarFill, BIconStar, BIconStarHalf, BFormGroup, BFormTextarea, BFormInput, BButton } from 'bootstrap-vue'
import LabeledText from '@/components/base/ui/LabeledText.vue'
import BaseTextarea from '@/components/base/forms/BaseTextarea'
export default {
  name: 'report',
  components: {
    LabeledText,
    BaseTextarea,
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BButton
  },
  props: {
  },
  data () {
    return {
      tratamiento: '',
      report: {
        filled: false,
        reason: '',
        history: '',
        treatment: '',
        diagnosis: ''
      }
    }
  },
  mounted () {
    if (sessionStorage.report) this.report = JSON.parse(sessionStorage.getItem('report'))
  },
  watch: {
    report: {
     handler (val) {
       sessionStorage.setItem('report', JSON.stringify(this.report))
     },
     deep: true
    }
  }
}
</script>

<style lang="less">
body {
  text-align:left !important;
}
</style>




// WEBPACK FOOTER //
// src/components/webapp/professional/report.vue